<template>
  <div class="clinic-search-form">
    <b-card>
      <template #header>
        <h5 class="mb-0">
          <i class="fas fa-search mr-2"></i>
          Branch Search
        </h5>
      </template>

      <b-form @submit.prevent="onSubmit" @reset="onReset">
        <!-- Search Fields -->
        <b-row>
          <b-col md="4">
            <b-form-group label="Name" label-for="clinicName">
              <b-form-input
                id="clinicName"
                v-model="form.clinicName"
                placeholder="Enter clinic/branch name"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
          
          <b-col md="4">
            <b-form-group label="Address" label-for="address">
              <b-form-input
                id="address"
                v-model="form.address"
                placeholder="Enter address"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
          
          <b-col md="4">
            <b-form-group label="Hospital Code" label-for="hospitalCode">
              <b-form-input
                id="hospitalCode"
                v-model="form.hospitalCode"
                placeholder="Enter hospital code"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Action Buttons -->
        <b-row class="mt-3">
          <b-col>
            <b-button-group>
              <b-button
                type="submit"
                variant="primary"
                :disabled="isLoading"
              >
                <i class="fas fa-search mr-1"></i>
                Search Branches
              </b-button>
              
              <b-button
                type="reset"
                variant="outline-secondary"
                :disabled="isLoading"
              >
                <i class="fas fa-times mr-1"></i>
                Clear
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>

        <!-- Search Results Summary -->
        <b-row v-if="lastSearchCriteria" class="mt-3">
          <b-col>
            <b-alert show variant="info" class="mb-0">
              <small>
                <strong>Last Search:</strong>
                <span v-for="(value, key) in lastSearchCriteria" :key="key" class="mr-2">
                  <strong>{{ formatSearchKey(key) }}:</strong> {{ value }}
                </span>
              </small>
            </b-alert>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "ClinicSearchForm",
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    lastSearchCriteria: {
      type: Object,
      default: () => ({})
    },
    hasResults: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        clinicName: '',
        address: '',
        hospitalCode: ''
      }
    };
  },
  methods: {
    onSubmit() {
      const searchParams = this.buildSearchParams();
      this.$emit('search', searchParams);
    },
    
    onReset() {
      this.form = {
        clinicName: '',
        address: '',
        hospitalCode: ''
      };
    },
    
    buildSearchParams() {
      const params = {};
      
      // Add non-empty string values
      Object.keys(this.form).forEach(key => {
        const value = this.form[key];
        if (value !== null && value !== undefined && value !== '') {
          params[key] = value;
        }
      });
      
      return params;
    },
    
    formatSearchKey(key) {
      const keyMap = {
        clinicName: 'Name',
        address: 'Address',
        hospitalCode: 'Hospital Code'
      };
      return keyMap[key] || key;
    }
  }
};
</script>

<style scoped>
.clinic-search-form .card {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
}

.clinic-search-form .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.clinic-search-form .form-group label {
  font-weight: 500;
  color: #495057;
}

.clinic-search-form .btn-group .btn {
  border-radius: 0.375rem;
}

.clinic-search-form .btn-group .btn:not(:last-child) {
  margin-right: 0.5rem;
}
</style>